import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsFirmAdmin = createSelector(
  (state: RootState) => state.user.roles,
  (roles: string[]) => roles.includes('firm-admin')
)

export default selectIsFirmAdmin
